import { API } from 'aws-amplify';

// eslint-disable-next-line no-unused-vars
function init(arg0: string, arg1: string, _init: any, any: any)
{
	throw new Error('Function not implemented.');
}

export function searchMember(body:any, query:any)
{
	return API.post('folderManagement', `/folders${query}`, { body });
}
export function postAddParticipant(body:any)
{
	return API.post('folderManagement', '/addParticipant', { body });
}
export function getMeetingsData(query:any):Promise<any>
{
	return API.get('folderManagement', `/trainingWebinar${query}`, init);
}
export function memberSearch(query:any)
{
	return API.get('folderManagement', `/shareWith${query}`, init);
}
export function createTrainingWebinar(query:any, body:any):Promise<any>
{
	return API.post('folderManagement', `/trainingWebinar${query}`, { body });
}
export function updateTrainingWebinar(queryStringParameters:any, body:any):Promise<any>
{
	return API.put('folderManagement', '/trainingWebinar', { queryStringParameters, body });
}
export function deleteTrainingWebinar(query:any)
{
	return API.del('folderManagement', `/trainingWebinar${query}`, init);
}
export function getCohostsList(query:any):Promise<any>
{
	return API.get('folderManagement', `/getCoHosts${query}`, init);
}
export function getInviteesList(query:any):Promise<any>
{
	return API.get('folderManagement', `/getinvitees${query}`, init);
}
export function getParticipantsList(query:any):Promise<any>
{
	// return API.get('folderManagement', `/getTrainingWebinarById${query}`, init);
	return API.get('folderManagement', `/getTrainingWebinarByID${query}`, init);
}
export function BookSeat(queryStringParameters:any, body:any):Promise<any>
{
	return API.post('folderManagement', '/bookSeat', { queryStringParameters, body });
}
export function BookSeats(body)
{
	return API.post('folderManagement', '/bookSeat', { body });
}
// export function getSocketChat(id:any)
// {
// 	return API.get('InVcMainchat', `/getChat?meetingId=${id}`, init);
// }
export function getSocketChat(queryStringParameters:any)
{
	// return API.get('InVcMainchat', '/getAllChat ', { queryStringParameters });
	return API.get('InVcMainchat', '/getChat ', { queryStringParameters });
}
export function getAllChatFromSocket(queryStringParameters:any)
{
	return API.get('InVcMainchat', '/getAllChat ', { queryStringParameters });
}
export function postSocketChat(obj:any)
{
	return API.post('InVcMainchat', '/createChat', { body: obj });
}
export function getChatList(meetingId:any)
{
	return API.get('InVcMainchat', `/getAllChat?meetingId=${meetingId}`, init);
}
export function JoinMeeting(query:any)
{
	return API.put('folderManagement', `/join${query}`, init);
}
export function getCalendarDetails(query:any):Promise<any>
{
	return API.get('folderManagement', `/getCalender${query}`, init);
}
export function getRegisterAndRequest(queryStringParameters:any)
{
	return API.get('folderManagement', '/getRegisterAndRequest', { queryStringParameters });
}

export function acceptDecline(body:any)
{
	return API.put('folderManagement', '/acceptDecline', { body });
}
export function NewJoinMeeting(body:any)
{
	return API.post('folderManagement', '/join', { body });
}
export function getTNndWebById(queryStringParameters:any)
{
	return API.get('folderManagement', '/getTrainingWebinarByID', { queryStringParameters });
}
export function getPollHistory(query:any)
{
	return API.get('trainingWebinarPoll', `/getPollsResult/${query}`, init);
}
export function getTWRecordings(query:any, md5Hash:any)
{
	return API.get('twRecordings', `/getsessionlogs${query}`, 	{ headers : {
		Authorization  : `Bearer ${md5Hash}`,
		'Content-Type' : 'application/json'
	},
	maxBodyLength : Infinity
	});
}